<template>
  <main
    class="boot"
    data-testid="app-boot-skeleton"
    aria-label="Carregando"
    aria-busy="true"
  >
    <header class="topbar">
      <div class="brand">
        <span class="skeleton skeleton--pin" />
        <span class="skeleton brand__name" />
      </div>
      <div class="field field--farm">
        <span class="skeleton field__label" />
        <span class="skeleton control" />
      </div>
      <div class="field field--day">
        <span class="skeleton field__label" />
        <span class="skeleton control" />
      </div>
      <div class="actions">
        <span class="skeleton button button--animals" />
        <span class="skeleton button button--history" />
        <span class="skeleton button button--exit" />
      </div>
    </header>

    <section
      class="kpis"
      aria-hidden="true"
    >
      <div
        v-for="index in 4"
        :key="index"
        class="kpi"
      >
        <span class="skeleton kpi__label" />
        <span class="skeleton kpi__value" />
      </div>
    </section>

    <section
      class="map-card"
      aria-hidden="true"
    >
      <div class="terrain">
        <span class="terrain__pasture terrain__pasture--one" />
        <span class="terrain__pasture terrain__pasture--two" />
        <span class="terrain__pasture terrain__pasture--three" />
        <span class="terrain__road" />
      </div>
      <div class="map-controls">
        <span /><span />
      </div>
      <div class="legend">
        <span /><i /><span /><i /><span /><i />
      </div>
    </section>
  </main>
</template>

<style scoped>
.boot {
  --border: hsl(214 20% 90%);
  --radius: 14px;
  --shadow: 0 1px 2px hsl(222 47% 11% / 0.05), 0 2px 8px hsl(222 47% 11% / 0.04);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-height: 100dvh;
  padding: 0.75rem 1rem 1rem;
  box-sizing: border-box;
  background: hsl(210 20% 98%);
}
.topbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;
  padding: 0.75rem 1rem;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}
.brand { display: flex; align-items: center; gap: 0.45rem; margin-right: auto; align-self: center; }
.field { display: flex; flex-direction: column; gap: 0.2rem; }
.field--farm { width: 11.8rem; }
.field--day { width: 9.7rem; }
.actions { display: flex; gap: 0.5rem; }
.skeleton {
  display: block;
  background: hsl(150 8% 88%);
  animation: breathe 2.8s ease-in-out infinite;
}
.skeleton--pin { width: 1.35rem; height: 1.35rem; border-radius: 50% 50% 50% 0; transform: rotate(-45deg); background: hsl(142 30% 72%); }
.brand__name { width: 7.7rem; height: 1.05rem; border-radius: 0.35rem; }
.field__label { width: 3.2rem; height: 0.55rem; border-radius: 0.2rem; }
.control, .button { height: 2.5rem; border-radius: calc(var(--radius) - 4px); }
.button--animals { width: 5.8rem; }
.button--history { width: 11.4rem; }
.button--exit { width: 4rem; }
.kpis { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 0.75rem; }
.kpi {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 0.7rem 1rem;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}
.kpi__label { width: 7.4rem; height: 0.65rem; border-radius: 0.25rem; }
.kpi__value { width: 3.3rem; height: 1.6rem; border-radius: 0.35rem; }
.map-card {
  position: relative;
  flex: 1 1 auto;
  min-height: 24rem;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  background: #74806c;
}
.terrain {
  position: absolute;
  inset: 0;
  overflow: hidden;
  background:
    radial-gradient(ellipse at 9% 22%, hsl(139 25% 27%) 0 11%, transparent 12%),
    radial-gradient(ellipse at 88% 82%, hsl(133 20% 29%) 0 14%, transparent 15%),
    linear-gradient(105deg, hsl(97 17% 39%) 0 19%, hsl(74 14% 50%) 19% 42%, hsl(30 25% 49%) 42% 67%, hsl(82 18% 43%) 67% 100%);
  filter: saturate(0.65);
}
.terrain::before, .terrain::after { content: ''; position: absolute; background: hsl(31 30% 66% / 0.75); }
.terrain::before { width: 140%; height: 4%; left: -15%; top: 48%; transform: rotate(-8deg); }
.terrain::after { width: 3%; height: 140%; left: 66%; top: -20%; transform: rotate(18deg); }
.terrain__pasture { position: absolute; border: 2px solid hsl(73 16% 68% / 0.8); background: hsl(89 18% 44% / 0.5); }
.terrain__pasture--one { width: 22%; height: 35%; left: 32%; top: 12%; transform: rotate(-7deg); }
.terrain__pasture--two { width: 22%; height: 34%; left: 35%; top: 51%; transform: rotate(-7deg); }
.terrain__pasture--three { width: 17%; height: 58%; left: 57%; top: 19%; transform: rotate(11deg); }
.terrain__road { position: absolute; width: 1.2%; height: 100%; left: 28%; top: 0; transform: rotate(-13deg); background: hsl(35 24% 70% / 0.7); }
.map-controls { position: absolute; top: 0.75rem; left: 0.75rem; display: grid; gap: 1px; padding: 2px; border-radius: 4px; background: #fff; box-shadow: var(--shadow); }
.map-controls span { width: 1.65rem; height: 1.65rem; background: hsl(150 8% 88%); }
.legend { position: absolute; right: 0.75rem; bottom: 1.75rem; display: grid; grid-template-columns: 0.7rem 4.5rem; gap: 0.35rem 0.4rem; padding: 0.55rem; border-radius: var(--radius); background: #fff; box-shadow: var(--shadow); }
.legend span { width: 0.7rem; height: 0.7rem; border-radius: 50%; background: hsl(150 8% 82%); }
.legend i { width: 4.5rem; height: 0.55rem; border-radius: 0.2rem; background: hsl(150 8% 88%); }
@keyframes breathe { 0%, 100% { opacity: 0.72; } 50% { opacity: 1; } }
@media (max-width: 900px) { .kpis { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 640px) {
  .boot { padding: 0.5rem; gap: 0.5rem; }
  .topbar { padding: 0.6rem 0.75rem; }
  .brand, .field, .actions { width: 100%; }
  .actions > * { flex: 1 1 0; }
  .map-card { min-height: 60dvh; }
}
@media (prefers-reduced-motion: reduce) { .skeleton { animation: none; opacity: 0.85; } }
</style>
